import {DocumentsCard} from './components/Docs'

export function TabDoc() {
  return (
    <div className='tab-pane fade' id='tab-doc' role='tabpanel' aria-labelledby='tab-doc-tab'>
      <div className='row ' style={{alignItems: 'stretch'}}>
        <div className='col-12 d-flex'>
          <DocumentsCard />
        </div>
      </div>
    </div>
  )
}
